import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';
import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { isDev } from '@zg-rentals/environment-utils';
import { RentalManagerBrowserEnvironment } from '@zg-rentals/rental-manager-env-base';
import { createBrowserLoggerBindings } from './loggerUtils';
import { makeDefaultEnvironment } from '../components';
import { type Logger, setGlobalLogger } from '@zg-rentals/logger-base';

declare global {
  interface Window {
    log: Logger;
  }
}

export type InitializeBrowserOptions = {
  appName: string;
  onBootstrapRegister?: () => void;
};

export const initializeBrowser = ({
  zgApi,
  appName,
  buildNumber,
  onBootstrapRegister,
}: {
  zgApi: string;
  buildNumber: number;
} & InitializeBrowserOptions): RentalManagerEnvironment => {
  const defaultEnv = makeDefaultEnvironment(zgApi);
  const instance: RentalManagerEnvironment = RentalManagerBrowserEnvironment.setInstance(defaultEnv);
  instance.isNodeLess = true;
  instance.isClient = true;
  instance.isServer = false;

  const isProd = !isDev();
  const builder = new BootstrapBrowserBuilder(appName, buildNumber)
    .withLoggerOptions({
      logPath: isProd ? `/rental-manager-api/hostedApp/log?appName=${appName}` : undefined,
      level: isProd ? 'error' : 'info',
      browser: {
        serialize: true,
      },
    })
    .withOnRegister(() => onBootstrapRegister?.());

  const bootstrap = builder.build();

  // Note: maybe todo, await?
  bootstrap.register();

  instance.monitor = bootstrap.monitor;
  instance.logger = bootstrap.logger.child(createBrowserLoggerBindings());

  setGlobalLogger(instance.logger);
  window.log = instance.logger;

  return instance;
};

export const getFrontEndInstance = (): RentalManagerEnvironment => {
  return RentalManagerBrowserEnvironment.getInstance();
};
